import { ReactElement } from "react"
import { Link } from "react-router-dom";
import "./menuItem.css";

interface MenuItem {
    icon: ReactElement;
    name: string;
    route?: string;
    handleClick?: () => void;
}

export function MenuItem({icon, name, route, handleClick = () => {}}: MenuItem) {
    return (
        <div className="bufete-menu-item">
            {icon}
            {route ? <Link to={route}>{name}</Link> : <p onClick={() => handleClick()}>{name}</p>}
            
        </div>
    )
}